import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { AppState } from '../../data/state'

import FormQuantity from 'components/FormQuantity'
import { Modal, ModalFooter } from 'components/Modal'

import { Baby, Traveler } from '../../data/models/funnelOrder/travelers'
import { SRPRS_ENV } from '../../env'

const totalPeople = 9

interface IPerson {
  adults: number
  childs: number
  babies: number
}

interface PersonModalProps extends IPerson {
  view: boolean
  onDismiss: () => void
  onSave: (value: IPerson) => void
}

class PersonModal extends React.Component<PersonModalProps, IPerson> {
  constructor(props: PersonModalProps) {
    super(props)
    this.state = {
      adults: props.adults,
      childs: props.childs,
      babies: props.babies,
    }
    this.updateAdults = this.updateAdults.bind(this)
    this.updateChildren = this.updateChildren.bind(this)
    this.updateBabies = this.updateBabies.bind(this)
  }

  public handleDismiss = (save: boolean) => {
    this.props.onDismiss()
    if (save) {
      this.props.onSave(this.state)
    }
  }

  public updateAdults(adults: number) {
    this.setState({ adults })
  }

  public updateChildren(childs: number) {
    this.setState({ childs })
  }

  public updateBabies(babies: number) {
    this.setState({ babies })
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.view ? (
          <Modal
            onDismiss={() => this.handleDismiss(false)}
            backdrop={true}
            animationType={'1'}
            size={'m'}
            sticky={true}
            disableOutsideClick={SRPRS_ENV === 'editable'}
            headerlessModal={true}
          >
            <div className="content">
              <FormQuantity
                max={totalPeople - this.state.childs}
                onChange={this.updateAdults}
                type="outside"
                heading={
                  <DisplayContent edit={true} contentKey="adults">
                    Adults
                  </DisplayContent>
                }
                subHeading={
                  <DisplayContent edit={true} contentKey="from-18-years">
                    From 18 years
                  </DisplayContent>
                }
                min={1}
                defaultQuantity={this.props.adults}
              />
              <FormQuantity
                max={totalPeople - this.state.adults}
                onChange={this.updateChildren}
                type="outside"
                heading={
                  <DisplayContent edit={true} contentKey="children">
                    Children
                  </DisplayContent>
                }
                subHeading={
                  <DisplayContent edit={true} contentKey="between-2-17-years">
                    2-17 years
                  </DisplayContent>
                }
                defaultQuantity={this.props.childs}
              />
              <FormQuantity
                max={this.state.adults}
                onChange={this.updateBabies}
                type="outside"
                heading={
                  <DisplayContent edit={true} contentKey="babies">
                    Babies
                  </DisplayContent>
                }
                subHeading={
                  <DisplayContent edit={true} contentKey="between-0-23-months">
                    0-23 months
                  </DisplayContent>
                }
                defaultQuantity={this.props.babies}
              />
            </div>
            <ModalFooter
              onClose={() => this.handleDismiss(false)}
              onSave={() => this.handleDismiss(true)}
            />
          </Modal>
        ) : null}
      </React.Fragment>
    )
  }
}

export default connect(
  (state: AppState) => ({
    adults: state.funnelOrder.numberOfAdults,
    childs: state.funnelOrder.numberOfChildren,
    babies: state.funnelOrder.numberOfBabies,
    view: state.ui.viewPersonModal,
  }),
  dispatch => ({
    onSave: (value: IPerson) => {
      dispatch(actions.change('funnelOrder.numberOfAdults', value.adults))
      dispatch(actions.change('funnelOrder.numberOfChildren', value.childs))
      dispatch(actions.change('funnelOrder.numberOfBabies', value.babies))
    },
    onDismiss: () => {
      dispatch(actions.change('ui.viewPersonModal', false))
    },
  }),
)(PersonModal)
